import { Scatter } from '@ant-design/plots';
import {useAntCharts} from "../../../charts/ant/useAntCharts";
import { shortenSector } from "../../../utils/abbreviations";

const SectorScatter = ({tickerData}) => {
  const { axisConfig } = useAntCharts();
  const transformedTickerData = tickerData.filter(x=>x?.sector).map(x => ({...x, sector: shortenSector(x.sector)}));
  const config = {
    data: transformedTickerData,
    autoFit: true,
    coordinate: { transform: [{ type: 'transpose' }] },
    interaction: { tooltip: { shared: true } },
    xField: 'sector',
    yField: 'wgt',
    colorField: 'sector',
    shapeField: 'point',
    scale: { color: { palette: 'spectral' } },
    tooltip: { title: 'state', items: ['sector'] },
    annotations: [
      {
        type: 'link',
        xField: 'sector',
        yField: 'wgt',
        transform: [{ type: 'groupX', y: 'min', y1: 'max' }],
        scale: { y: { labelFormatter: '.0%' } },
        style: { stroke: 'transparent' },
        tooltip: false,
      },
    ],
    axis: {
      x: {
        ...axisConfig,
      },
        y: {
            ...axisConfig,
            title: 'Weight (%)',
        },
    },
    legend: false
  };
  return <Scatter {...config} />;
};


export default SectorScatter;